'use strict';

/* eslint no-undef: "off" */
/**
 * XPark find store
 */
define('xparkFindStore',['xparkHomepageApi', 'getCityListApi', 'svgIcon'], function (xparkHomepageApi, getCityListApi, svgIcon) {
  return {
    template: '\n      <section class="xp-find-store" v-if="stores.length || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="stores.length">\n          <div class="xp-find-store-header">\n            <h2 v-text="title"></h2>\n            <a class="xp-find-store-more" :href="moreUrl">\n              <span>More></span>\n            </a>\n          </div>\n\n          <div class="xp-find-store-viewport">\n            <ul class="xp-store-track">\n              <li\n                v-for="store in stores"\n                :key="store.name"\n                class="xp-store-slide"\n              >\n                <a class="xp-store-card" :href="store.url" :aria-label="store.name">\n                  <span class="xp-store-tags" v-if="store.tags.length">\n                    <span\n                      v-for="tag in store.tags"\n                      :key="tag"\n                      class="xp-store-tag"\n                      v-text="tag"\n                    ></span>\n                  </span>\n\n                  <strong class="xp-store-name" v-text="store.name"></strong>\n\n                  <span class="xp-store-rating">\n                    <span class="xp-store-stars" aria-hidden="true">\n                      <i\n                        v-for="star in 5"\n                        :key="star"\n                        :class="{ \'is-active\': star <= store.ratingStarCount }"\n                      ></i>\n                    </span>\n                    <span class="rate-num" v-text="store.rating"></span>\n                    <em v-if="store.reviews" v-text="\'(\' + store.reviews + \')\'"></em>\n                  </span>\n\n                  <span class="xp-store-detail-row">\n                    <svg-icon type="time" width="16" height="16"></svg-icon>\n                    <span class="xp-store-hours">\n                      <span\n                        v-for="(hour, hourIndex) in store.hours"\n                        :key="store.name + \'-hour-\' + hourIndex"\n                        v-text="hour"\n                      ></span>\n                    </span>\n                  </span>\n\n                  <span class="xp-store-detail-row">\n                    <svg-icon type="phone" width="16" height="16"></svg-icon>\n                    <span v-text="store.phone"></span>\n                  </span>\n\n                  <span class="xp-store-detail-row xp-store-address-row">\n                    <svg-icon type="location" width="16" height="16"></svg-icon>\n                    <span class="xp-store-address" v-text="store.address"></span>\n                    <b class="xp-store-distance" v-if="store.distance" v-text="store.distance"></b>\n                  </span>\n                </a>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </section>\n    ',
    components: {
      svgIcon: svgIcon
    },
    data: function data() {
      return {
        title: 'Infinix Store',
        moreUrl: '/stores',
        storeList: [],
        currentCityName: '',
        browserLatitude: null,
        browserLongitude: null,
        stores: [],
        loading: true
      };
    },
    mounted: function mounted() {
      this.getCityList();
      this.fetchBrowserLocation();
    },

    methods: {
      getCityList: function getCityList() {
        var _this = this;

        this.loading = true;
        getCityListApi().then(function (resData) {
          _this.currentCityName = _this.resolveSelectedCityName(Array.isArray(resData) ? resData : []);
          _this.fetchOfflineStores();
        }).catch(function () {
          _this.fetchOfflineStores();
        }).finally(function () {
          _this.loading = false;
        });
      },
      fetchOfflineStores: function fetchOfflineStores() {
        var _this2 = this;

        var params = this.currentCityName ? { city_name: this.currentCityName } : {};

        xparkHomepageApi.getOfflineStores(params).then(function (data) {
          var list = data && data.list;

          if (!Array.isArray(list) || !list.length) {
            return;
          }

          _this2.storeList = list;
          _this2.updateStores();
        }).catch(function () {});
      },
      resolveSelectedCityName: function resolveSelectedCityName(areaList) {
        var _this3 = this;

        var defaultArea = areaList[0] || null;
        var defaultCity = this.getDefaultCity(defaultArea);

        areaList.forEach(function (area) {
          if (_this3.isDefault(area)) {
            defaultArea = area;
            defaultCity = _this3.getDefaultCity(area);
          }
        });

        return defaultCity ? defaultCity.name || defaultCity.text || '' : '';
      },
      getDefaultCity: function getDefaultCity(area) {
        var _this4 = this;

        var children = this.getChildren(area);
        var defaultCity = children[0] || null;

        children.forEach(function (city) {
          if (_this4.isDefault(city)) {
            defaultCity = city;
          }
        });

        return defaultCity;
      },
      getChildren: function getChildren(area) {
        return area && Array.isArray(area.children) ? area.children : [];
      },
      isDefault: function isDefault(item) {
        return item && item.is_default === 1;
      },
      fetchBrowserLocation: function fetchBrowserLocation() {
        var _this5 = this;

        if (!navigator.geolocation) {
          return;
        }

        navigator.geolocation.getCurrentPosition(function (position) {
          _this5.browserLatitude = position && position.coords ? position.coords.latitude : null;
          _this5.browserLongitude = position && position.coords ? position.coords.longitude : null;
          _this5.updateStores();
        }, function () {}, {
          enableHighAccuracy: false,
          timeout: 8000,
          maximumAge: 300000
        });
      },
      updateStores: function updateStores() {
        var _this6 = this;

        if (!Array.isArray(this.storeList) || !this.storeList.length) {
          return;
        }

        this.stores = this.storeList.map(function (item, index) {
          var distanceValue = _this6.getStoreDistanceValue(item.latitude, item.longitude);

          return {
            originalIndex: index,
            tags: Array.isArray(item.tags) ? item.tags : [],
            name: item.title || '',
            rating: item.score || '0',
            ratingStarCount: _this6.getRatingStarCount(item.score),
            reviews: item.review_count || 0,
            hours: _this6.formatOpeningHours(item.opening_hours),
            phone: item.phone || '',
            address: item.address || '',
            distance: _this6.formatDistance(distanceValue),
            distanceValue: distanceValue,
            url: item.url || 'javascript:void(0);'
          };
        }).filter(function (item) {
          return item.name;
        }).sort(function (first, second) {
          if (first.distanceValue === null && second.distanceValue === null) {
            return first.originalIndex - second.originalIndex;
          }

          if (first.distanceValue === null) {
            return 1;
          }

          if (second.distanceValue === null) {
            return -1;
          }

          return first.distanceValue - second.distanceValue;
        });
      },
      normalizeRatingScore: function normalizeRatingScore(value) {
        var parsed = parseFloat(value);

        if (isNaN(parsed)) {
          return 0;
        }

        if (parsed < 0) {
          return 0;
        }

        if (parsed > 5) {
          return 5;
        }

        return parsed;
      },
      getRatingStarCount: function getRatingStarCount(score) {
        return Math.floor(this.normalizeRatingScore(score));
      },
      formatOpeningHours: function formatOpeningHours(openingHours) {
        var _this7 = this;

        if (!Array.isArray(openingHours) || !openingHours.length) {
          return [];
        }

        return openingHours.map(function (item) {
          var weekdays = Array.isArray(item.weekdays) ? item.weekdays.filter(Boolean) : [];
          var startMinute = item.start_minute || item.start_second || '00';
          var endMinute = item.end_minute || item.end_second || '00';
          var weekdayText = _this7.formatWeekdayRange(weekdays);
          var timeText = (item.start_hour || '00') + ':' + startMinute + '-' + (item.end_hour || '00') + ':' + endMinute;

          return weekdayText ? weekdayText + ' ' + timeText : timeText;
        }).filter(Boolean);
      },
      formatWeekdayRange: function formatWeekdayRange(weekdays) {
        if (!Array.isArray(weekdays) || !weekdays.length) {
          return '';
        }

        if (weekdays.length === 1) {
          return weekdays[0];
        }

        return weekdays[0] + '-' + weekdays[weekdays.length - 1];
      },
      getStoreDistance: function getStoreDistance(latitude, longitude) {
        return this.formatDistance(this.getStoreDistanceValue(latitude, longitude));
      },
      getStoreDistanceValue: function getStoreDistanceValue(latitude, longitude) {
        var storeLatitude = this.parseCoordinate(latitude);
        var storeLongitude = this.parseCoordinate(longitude);

        if (storeLatitude === null || storeLongitude === null || this.browserLatitude === null || this.browserLongitude === null) {
          return null;
        }

        return this.calculateDistance(this.browserLatitude, this.browserLongitude, storeLatitude, storeLongitude);
      },
      parseCoordinate: function parseCoordinate(value) {
        var parsed = parseFloat(value);

        return Number.isNaN(parsed) ? null : parsed;
      },
      calculateDistance: function calculateDistance(startLatitude, startLongitude, endLatitude, endLongitude) {
        var earthRadius = 6371;
        var latitudeDelta = this.toRadians(endLatitude - startLatitude);
        var longitudeDelta = this.toRadians(endLongitude - startLongitude);
        var haversine = Math.sin(latitudeDelta / 2) * Math.sin(latitudeDelta / 2) + Math.cos(this.toRadians(startLatitude)) * Math.cos(this.toRadians(endLatitude)) * Math.sin(longitudeDelta / 2) * Math.sin(longitudeDelta / 2);
        var centralAngle = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));

        return earthRadius * centralAngle;
      },
      formatDistance: function formatDistance(distance) {
        if (!distance && distance !== 0) {
          return '';
        }

        if (distance < 1) {
          return Math.round(distance * 1000) + 'm';
        }

        return distance.toFixed(distance < 10 ? 1 : 0) + 'km';
      },
      toRadians: function toRadians(value) {
        return value * Math.PI / 180;
      }
    }
  };
});
